import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import Datetime from 'react-datetime';
import { formatTimezoneDateTime } from 'helper/unit-helper';
import { Dropdown } from '../../components/Dropdown/Dropdown';
import Input from 'components/react-validation/components/input';
import * as Vali from 'helper/validator-helper';
import { decimalFixed } from 'helper/unit-helper';
import Form from 'components/react-validation/components/form';
import Textarea from '../../components/react-validation/components/text-area';
import Submit from '../../components/react-validation/components/submit';
import * as LotActionType from '../../Lots/constants';
import * as WorkOrderActionType from '../constants';
import * as SubcontractorActionType from '../../Subcontractors/constants';

class AddBackCharge extends Component {

  static propTypes = {
    dispatch: PropTypes.func,
    match: PropTypes.object,
    tradeSelectList: PropTypes.array,
    userProfile: PropTypes.object,
    history: PropTypes.any,
    subcontractorSelectList: PropTypes.array,
    WorkOrderProfile: PropTypes.object
  }

  constructor(props) {

    super(props);

    let rfsId = null;
    let workOrderId = null;
    let purchaseOrderId = null;

    if (props.match.params.RFSID) {
      rfsId = props.match.params.RFSID;
    }

    if (props.match.params.WOID) {
      workOrderId = props.match.params.WOID;
    }

    if (props.match.params.POID) {
      purchaseOrderId = props.match.params.POID;
    }

    this.state = {
      rfsId: rfsId,
      workOrderId: workOrderId,
      purchaseOrderId
    };
  }

  componentDidMount() {
    this.fetWorkOrderById();
  }

  fetWorkOrderById = () => {
    this.props.dispatch({
      type: WorkOrderActionType.GET_WORK_ORDER_DETAIL_ASYNC,
      params: {
        woRefNo: this.state.workOrderId,
        rfsRefNo: this.state.rfsId
      },
      callback: (data) => {
        this.fetchTradeSelectList(data, true);
        this.fetchSubcontractor(data, true);
      }
    });
  }

  fetchTradeSelectList = (data) => {
    if (data) {
      this.props.dispatch({
        type: LotActionType.SELECT_TRADE_ASYNC,
        params: {
          id: data.requestDetail.lot.id,
          searchKey: '',
          selectedValue: '',
          setDefaultSelected: false
        },
        callback: () => {
          const { workOrder } = data;

          const { trade } = workOrder;

          this.setState({
            trade: {
              value: trade.id,
              text: trade.name
            }
          });
        }
      });
    } else {
      const {WorkOrderProfile} = this.props;
      this.props.dispatch({
        type: LotActionType.SELECT_TRADE_ASYNC,
        params: {
          id: WorkOrderProfile.requestDetail.lot.id,
          searchKey: '',
          selectedValue: '',
          setDefaultSelected: false
        }
      });
    }
  }

  fetchSubcontractor = (data) => {
    if (data) {
      this.props.dispatch({
        type: SubcontractorActionType.SELECT_LIST_SUBCONTRACTOR_ASYNC,
        params: {
          projectId: data.requestDetail.project.id,
          lotId: data.requestDetail.lot.id,
          tradeId: data.workOrder.trade.id,
          param: {
            searchKey: '',
            selectedValue: ''
          }
        },callback: () => {
          const { workOrder } = data;
          const {subcontractorSelectList} = this.props;
          const subId = subcontractorSelectList.map(i => i.value);
          const { subcontractorProfile } = workOrder;
          { subId.includes(subcontractorProfile.subcontractorId) ? this.setState({
            chargedTo: subcontractorProfile ? {
              value: subcontractorProfile.subcontractorId,
              text: subcontractorProfile.companyName
            } : null
          }) : this.setState({ chargedTo: []});
          }
        }
      });
    } else {
      const {WorkOrderProfile} = this.props;
      this.props.dispatch({
        type: SubcontractorActionType.SELECT_LIST_SUBCONTRACTOR_ASYNC,
        params: {
          projectId: WorkOrderProfile.requestDetail.project.id,
          lotId: WorkOrderProfile.requestDetail.lot.id,
          tradeId: this.state.trade.value,
          param: {
            searchKey: '',
            selectedValue: ''
          }
        }
      });
    }
  }

  onSelectChange = (event, name) => {
    if (name === 'trade') {
      this.setState({[name]: event.value, chargedTo: null}, () => {
        this.fetchSubcontractor();
      });
    } else {
      this.setState({[name]: event.value});
    }
  }

  onSubmit = (e) => {
    e.preventDefault();

    const formData = this.form.getValues();
    formData.paymentDate = this.state.paymentDate ? formatTimezoneDateTime(this.state.paymentDate) : '';
    formData.purchaseOrderRefNo = this.state.purchaseOrderId;
    formData.tradeId = this.state.trade.value;
    formData.subcontractorId = this.state.chargedTo.value;
    formData.issuedDate = formatTimezoneDateTime(moment());
    formData.amount = decimalFixed(formData.amount);
    this.props.dispatch({
      type: WorkOrderActionType.CREATE_BACK_CHARGE_ASYNC,
      params: {
        data: formData,
        rfsId: this.state.rfsId
      },
      callback: (data) => {
        this.props.history.push(`/request-for-services/work-order/back-charge/${this.state.rfsId}/${this.state.workOrderId}/${this.state.purchaseOrderId}/detail/${data.refNo}`);
      }
    });
  }

  handleCancel = () => {
    this.props.history.push(`/request-for-services/work-order/purchase-order/${this.state.rfsId}/${this.state.workOrderId}/detail/${this.state.purchaseOrderId}`);
  }

  onChangePaymentDate = (paymentDate) => {
    if (paymentDate) {
      if (moment(paymentDate, 'MM/DD/YYYY HH:mm A', true).isValid()) {
        this.setState({
          paymentDate,
          error: null
        });
      } else {
        this.setState({
          error: 'Invalid datetime.'
        });
      }
    } else {
      this.setState({
        paymentDate
      });
    }
  }

  renderNewPurchaseOrder() {
    const disableSubmitButton = isEmpty(this.state.trade) || isEmpty(this.state.chargedTo || this.state.error);
    return (
      <div className='subcontractor box-form-siteone'>
        <div className='box-form-body'>
          <Form ref={ref => { this.form = ref; }} onSubmit={this.onSubmit}>
            <div className='row'>
              <div className='col-sm-4 col-xs-6'>
                <div className='form-group'>
                  <label>Trade <span className='text-danger'> *</span></label>
                  <Dropdown
                    onChange={ref => { this.onSelectChange(ref, 'trade'); }}
                    className='filestring-dropdown filter-dropdown'
                    options={this.props.tradeSelectList}
                    loading={this.state.isLoadingGetTradeSelectList}
                    optionLabel='text'
                    value={this.state.trade}
                    showClear={false}
                    onRemote={this.fetchTradeSelectList}
                    name='trade'
                    filter
                    placeholder='--Please select'
                    style={{ width: '100%', position: 'relative' }} />
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-sm-4 col-xs-6'>
                <div className='form-group'>
                  <label>Charged to <span className='text-danger'> *</span></label>
                  <Dropdown
                    onChange={ref => { this.onSelectChange(ref, 'chargedTo'); }}
                    className='filestring-dropdown filter-dropdown'
                    options={this.props.subcontractorSelectList}
                    loading={this.state.isLoadingGetSubcontractorSelectList}
                    optionLabel='text'
                    value={this.state.chargedTo}
                    onRemote={this.fetchSubcontractor}
                    showClear={false}
                    name='trade'
                    filter
                    placeholder='--Please select'
                    style={{ width: '100%', position: 'relative' }} />
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-sm-4 col-xs-6'>
                <div className='form-group'>
                  <label>Amount<span className='text-danger'> *</span></label>
                  <div style={{position: 'relative'}}>
                    <span className='addon-input'>$</span>
                    <Input
                      style={{paddingLeft: 20}}
                      type='text'
                      name='amount'
                      ref='amount'
                      className='form-control'
                      max='12'
                      maxLength='12'
                      errorMsg='Estimated amount is maximum 12 characters'
                      validations={[Vali.required, Vali.maxlength, Vali.isNumber]} />
                  </div>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-sm-10'>
                <div className='form-group'>
                  <label>Reason for issuing BC<span className='text-danger'> *</span></label>
                  <Textarea
                    className='form-control'
                    name='reason'
                    ref='reason'
                    max='500'
                    maxLength='500'
                    errorMsg='Reson for issuing PO is maximum 500 characters'
                    style={{height: 70}}
                    validations={[Vali.required,Vali.maxlength]} />
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-sm-6'>
                <div className='form-group row'>
                  <div className='col-lg-2 col-md-3 col-sm-4'>Issued date</div>
                  <div className='col-lg-10 col-md-9 col-sm-8'><strong>{moment().format('MM/DD/YYYY')}</strong></div>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-sm-6'>
                <div className='form-group row'>
                  <div className='col-lg-2 col-md-3 col-sm-4'>Issued by</div>
                  <div className='col-lg-10 col-md-9 col-sm-8'><strong>{this.props.userProfile.fullName}</strong></div>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-sm-4 col-xs-6'>
                <div className='form-group'>
                  <label>Payment received</label>
                  <Datetime
                    ref={ref => { this.paymentDate = ref; }}
                    name='paymentDate'
                    timeFormat={false}
                    inputProps={{ placeholder: 'mm/dd/yyyy' }}
                    value={this.state.paymentDate ? moment(this.state.paymentDate).format('MM/DD/YYYY') : ''}
                    onChange={this.onChangePaymentDate} 
                    closeOnSelect={true}/>
                  {this.state.error &&
                    <span className='text-danger' style={{fontSize: 12}}>{this.state.error}</span>
                  }

                </div>
              </div>
            </div>

            <div className='form-group' style={{ marginTop: 15 }}>
              <a className='btn btn-primary btn-siteone-default' onClick={this.handleCancel}>Cancel</a>
              <Submit className='btn btn-primary btn-submit btn-siteone' disabled={disableSubmitButton}>Create & Send</Submit>
            </div>
          </Form>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className='rfs-detail add-new-work-order'>
        <div className='page-title clearfix'>
          <h2 className='pull-left'>Add new back charge</h2>
        </div>
        <ul className='breadcrumb'>
          <li><Link to={'/request-for-services'}>Requests for service</Link></li>
          <li><Link to={`/request-for-services/${this.state.rfsId}`}>RFS # {this.state.rfsId}</Link></li>
          <li><Link to={`/request-for-services/work-order/detail/${this.state.rfsId}/${this.state.workOrderId}`}>WO #{this.state.workOrderId}</Link></li>
          <li><Link to={`/request-for-services/work-order/purchase-order/${this.state.rfsId}/${this.state.workOrderId}/detail/${this.state.purchaseOrderId}`}>PO #{this.state.purchaseOrderId}</Link></li>
          <li className='breadcrumb-siteone-li'>Add new back charge</li>
        </ul>
        {this.renderNewPurchaseOrder()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userProfile: state.UserStore.UserProfile,
    WorkOrderProfile: state.WorkOrderReducer.WorkOrderProfile,
    tradeSelectList: state.LotStore.TradeList,
    subcontractorSelectList: state.SubcontractorStore.SubcontractorList
  };
};

export default connect(mapStateToProps)(AddBackCharge);



// WEBPACK FOOTER //
// ./src/Work-Orders/Containers/add-back-charge.js